import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import { MattertagParams } from "@/interfaces/ContentsParams";

@Module({
  name: "contents",
  stateFactory: true,
  namespaced: true
})
export default class ContentsStore extends VuexModule {
  tags: MattertagParams[] = [];
  
  @Mutation
  setTagData (tagData: MattertagParams[]) {
    this.tags = tagData;
  }
}
